var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMudhalPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "140 125 890 270",
    id: "svg2",
    width: 300,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "auto",
      minWidth: 30,
      maxWidth: 300
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,412.237 H 869.188 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,549.64933)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.8668,281.0685)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 14.977 v -9.85 c 3.508,6.207 11.334,11.199 19.564,11.199 10.525,0 17.541,-4.587 21.049,-12.683 4.453,7.826 13.897,12.683 21.858,12.683 17.541,0 25.367,-10.794 25.367,-29.683 V -66.789 H 87.838 v 36.43 c 0,9.31 -2.024,17.271 -13.763,17.271 -9.58,0 -15.112,-7.556 -15.112,-16.596 V -66.789 H 43.986 v 36.43 c 0,9.31 -2.024,17.271 -13.762,17.271 -9.985,0 -15.247,-8.5 -15.247,-17.54 V -66.789 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.354,240.4553)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V 40.613 H 14.977 V 2.159 c 0,-10.66 4.723,-15.247 14.033,-15.247 10.389,0 15.921,8.635 15.921,18.215 V 40.613 H 59.908 V -26.176 H 45.74 v 10.255 C 41.693,-23.208 32.383,-27.525 24.287,-27.525 6.612,-27.525 0,-17.54 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.0067,247.6068)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,11.738 -7.826,20.374 -18.485,20.374 -11.334,0 -19.429,-8.636 -19.429,-20.374 0,-11.739 8.095,-20.239 19.429,-20.239 C -7.961,-20.239 0,-11.874 0,0 m -53.161,0 c 0,19.294 12.548,34.811 30.898,34.811 9.04,0 17.001,-3.643 22.263,-9.85 V 55.455 H 14.977 V -33.327 H 0.675 v 8.365 c -5.397,-6.206 -13.628,-9.715 -22.938,-9.715 -18.35,0 -30.898,15.517 -30.898,34.677"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(373.7358,303.062)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 14.977 v -31.573 c 4.857,7.421 12.548,10.929 21.454,10.929 17.54,0 24.017,-11.469 24.017,-29.819 V -88.782 H 45.471 v 36.43 c 0,10.929 -2.969,17.271 -14.033,17.271 -10.389,0 -16.461,-8.231 -16.461,-18.62 V -88.782 H 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 523.755,303.062 h 14.977 V 214.28 h -14.977 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.4741,161.9312)",
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,11.738 -8.095,20.239 -19.429,20.239 -10.525,0 -18.486,-8.366 -18.486,-20.239 0,-11.739 7.826,-20.374 18.486,-20.374 C -8.095,-20.374 0,-11.739 0,0 m -52.891,33.327 h 14.302 v -8.365 c 5.397,6.206 13.627,9.714 22.937,9.714 18.35,0 30.899,-15.516 30.899,-34.676 0,-19.295 -12.549,-34.812 -30.899,-34.812 -9.039,0 -17.001,3.644 -22.263,9.85 v -27.795 h -14.976 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384.8173,161.7964)",
    id: "g42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,11.738 -7.826,20.374 -18.485,20.374 -11.334,0 -19.43,-8.636 -19.43,-20.374 0,-11.739 8.096,-20.239 19.43,-20.239 C -7.961,-20.239 0,-11.874 0,0 m -53.161,0 c 0,19.294 12.548,34.811 30.898,34.811 9.04,0 17.001,-3.643 22.263,-9.849 v 8.5 H 14.977 V -33.327 H 0 v 8.365 c -5.262,-6.207 -13.223,-9.715 -22.263,-9.715 -18.35,0 -30.898,15.517 -30.898,34.677"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(411.9128,195.2581)",
    id: "g46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 14.977 v -13.223 c 2.563,6.747 9.85,14.572 24.152,14.572 v -16.326 c -14.707,0 -24.152,-7.016 -24.152,-24.556 V -66.789 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(506.4837,132.4312)",
    id: "g50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -3.102,-2.024 -8.503,-4.994 -16.06,-4.994 -13.62,0 -20.232,7.425 -20.232,22.804 v 33.057 h -9.855 v 12.286 h 9.855 v 11.19 c 1.466,-0.18 2.97,-0.275 4.493,-0.275 3.66,0 7.179,0.473 10.48,1.391 V 63.153 H -1.21 V 50.867 H -21.319 V 17.413 c 0,-7.16 3.377,-9.449 7.15,-9.449 5.259,0 9.714,3.235 9.714,3.235 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.5244,195.58)",
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 14.977 v -9.58 c 4.993,7.421 12.684,10.929 21.589,10.929 18.08,0 24.017,-12.008 24.017,-29.819 V -66.789 H 45.606 v 36.43 c 0,10.93 -2.429,17.271 -13.628,17.271 -9.85,0 -17.001,-7.691 -17.001,-18.755 V -66.789 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(637.9186,167.9199)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -1.484,9.58 -9.175,15.922 -18.35,15.922 -26.985,15.922 -34.541,9.58 -36.565,0 Z m -51.947,-5.802 c 0,19.16 14.977,34.812 34.407,34.812 17.81,0 32.112,-15.517 32.112,-34.272 0,-2.833 -0.404,-5.802 -0.404,-5.802 H -36.43 c 2.159,-10.659 10.794,-16.191 20.779,-16.191 6.746,0 13.762,2.024 19.16,5.801 l 5.936,-11.063 c -7.556,-5.128 -16.461,-7.961 -25.366,-7.961 -19.025,0 -36.026,12.683 -36.026,34.676"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(660.7189,195.58)",
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 14.977 v -13.223 c 2.564,6.747 9.85,14.572 24.152,14.572 v -16.326 c -14.707,0 -24.152,-7.016 -24.152,-24.556 V -66.789 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(704.6928,137.1567)",
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 5.667,12.278 c 4.317,-3.508 11.199,-7.96 21.184,-7.96 6.071,0 13.222,2.293 13.222,7.016 0,4.857 -6.746,6.072 -13.357,7.96 -12.684,3.509 -23.478,7.286 -23.478,20.375 0,13.088 13.358,20.104 25.096,20.104 9.985,0 16.597,-2.564 23.883,-6.882 L 46.685,40.748 c -5.937,3.373 -11.604,4.992 -18.215,4.992 -4.993,0 -9.985,-2.293 -9.985,-5.802 0,-4.587 5.532,-5.667 11.469,-6.881 C 42.367,30.359 55.32,25.366 55.32,11.604 55.32,-4.048 39.264,-9.715 26.851,-9.715 13.088,-9.715 3.643,-3.508 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496.9493,247.7965)",
    id: "g70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#4a5745",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,11.738 -7.826,20.374 -18.485,20.374 -11.334,0 -19.43,-8.636 -19.43,-20.374 0,-11.739 8.096,-20.239 19.43,-20.239 C -7.961,-20.239 0,-11.874 0,0 m -53.162,0 c 0,19.294 12.549,34.811 30.899,34.811 9.04,0 17.001,-3.643 22.263,-9.85 v 8.501 H 14.977 V -33.327 H 0 v 8.365 c -5.262,-6.206 -13.223,-9.715 -22.263,-9.715 -18.35,0 -30.899,15.517 -30.899,34.677"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(338.4016,247.6136)",
    id: "g74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#ff9230",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-6.469 -4.973,-11.712 -11.109,-11.712 -6.135,0 -11.108,5.243 -11.108,11.712 0,6.468 4.973,11.712 11.108,11.712 C -4.973,11.712 0,6.468 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.371,161.8636)",
    id: "g78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#ff9230",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-6.469 -4.973,-11.712 -11.109,-11.712 -6.135,0 -11.108,5.243 -11.108,11.712 0,6.468 4.973,11.712 11.108,11.712 C -4.973,11.712 0,6.468 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(299.6252,161.8636)",
    id: "g82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#ff9230",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-6.469 -4.973,-11.712 -11.109,-11.712 -6.135,0 -11.108,5.243 -11.108,11.712 0,6.468 4.973,11.712 11.108,11.712 C -4.973,11.712 0,6.468 0,0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMudhalPartners);
export default __webpack_public_path__ + "static/media/mudhal_partners.8edfa07160e2f8b34eb08e532bf15b21.svg";
export { ForwardRef as ReactComponent };